// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content .el-tabs__new-tab {\n  padding: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-color: #409EFF;\n}\n.content .el-tabs__new-tab i {\n  color: #409EFF;\n}\n.content .el-tabs__item {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n}\n.content .el-pagination .el-input__inner {\n  width: inherit;\n}", ""]);
// Exports
module.exports = exports;
